import { render, staticRenderFns } from "./Spectators.vue?vue&type=template&id=518dc0c2&scoped=true&"
import script from "./Spectators.vue?vue&type=script&lang=js&"
export * from "./Spectators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518dc0c2",
  null
  
)

export default component.exports